class Collapsible {
  constructor() {
    this.triggers = document.querySelectorAll('[data-collapsible-trigger]');
    this.contents = document.querySelectorAll('[data-collapsible-content]');
    this.init();
  }

  init() {
    if (!this.triggers.length || !this.contents.length) {
      console.error('No triggers or contents found');
      return;
    }
    if (this.triggers.length !== this.contents.length) {
      console.warn('Mismatch between triggers and contents:', this.triggers.length, this.contents.length);
    }
    this.triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        console.log('Trigger clicked:', index, trigger);
        this.toggle(index);
      });
    });
  }

  toggle(index) {
    const content = this.contents[index];
    const header = this.triggers[index];
    const wrapper = content ? content.closest('.collapsible__wrapper') : null;

    if (!content || !header || !wrapper) {
      console.error('Invalid elements at index', index, { header, content, wrapper });
      return;
    }

    const isOpen = wrapper.classList.contains('is-open');
    console.log('Toggling collapsible:', index, 'isOpen:', isOpen);

    if (isOpen) {
      console.log('Closing collapsible:', index);
      this.close(header, content, wrapper);
      return;
    }

    console.log('Closing all other collapsibles');
    this.closeAll();

    console.log('Opening collapsible:', index);
    this.open(header, content, wrapper);
  }

  closeAll() {
    this.triggers.forEach((trigger, i) => {
      const content = this.contents[i];
      const wrapper = content ? content.closest('.collapsible__wrapper') : null;
      if (!content || !wrapper) {
        console.warn('Invalid content or wrapper at index', i);
        return;
      }
      if (wrapper.classList.contains('is-open')) {
        console.log('Closing collapsible at index:', i);
        this.close(trigger, content, wrapper);
      }
    });
  }

  close(header, content, wrapper) {
    console.log('Removing is-open from wrapper:', wrapper);
    header.classList.remove('is-open');
    content.classList.remove('with-slow-transition');
    wrapper.classList.remove('is-open');
  }

  open(header, content, wrapper) {
    console.log('Adding is-open to wrapper:', wrapper);
    header.classList.add('is-open');
    content.classList.add('with-slow-transition');
    wrapper.classList.add('is-open');
  }
}

// Inicializa una sola instancia para toda la página
console.log('Initializing global collapsible');
new Collapsible();